<template>
  <div class="card_item">
    <div class="local_card_title medium" @click="$emit('select', cardInfo)">
      <div class="card_number">
        <div class="icon icon_radio" :class="{ active: isActive }"></div>
        <img
          v-if="cardInfo.paymentInstrumentData.network == 'VISA'"
          class="cardlogo"
          src="@img/primer/visa.png"
        />
        <img
          v-else-if="cardInfo.paymentInstrumentData.network == 'MASTERCARD'"
          class="cardlogo"
          src="@img/primer/mastercard.png"
        />
        <img
          v-else-if="cardInfo.paymentInstrumentData.network == 'JCB'"
          class="cardlogo"
          src="@img/primer/jcb.png"
        />
        <img
          v-else-if="cardInfo.paymentInstrumentData.network == 'DISCOVER'"
          class="cardlogo"
          src="@img/primer/discover.png"
        />
        <img
          v-else-if="cardInfo.paymentInstrumentData.network == 'AMEX'"
          class="cardlogo"
          src="@img/primer/amex.png"
        />
        <img v-else class="cardlogo" src="@img/primer/cardlogo.png" />
        <span>**** **** **** {{ cardInfo.paymentInstrumentData.last4Digits }}</span>
      </div>
      <p class="card_delete" @click.stop="$emit('deletecard', cardInfo)">
        {{ $t('primer.remove') }}
      </p>
    </div>
    <div :class="{ cvclocalCon: true, open: isActive }" v-if="isActive">
      <!-- 有效期 -->
      <div class="card_field disabled">
        <div class="card_filed_con">
          <div class="card_input_label">{{ $t('primer.date') }}*</div>
          <div class="card_input_content">
            {{
              cardInfo.paymentInstrumentData.expirationMonth +
              '/' +
              cardInfo.paymentInstrumentData.expirationYear
            }}
          </div>
        </div>
      </div>
      <!-- CVV/CVC -->
      <CvvInput :cardInfo="cardInfo" :vaultManager="vaultManager" ref="cvvInput" />
      <!-- 邮编 -->
      <FieldPostCode ref="postcodeInput" :defaultPostcode="postcode" v-if="isShowPostCode" />
    </div>
  </div>
</template>
<script>
import CvvInput from './cvvinput.vue'
import Field from './field.vue'
import FieldPostCode from '../customFields/FieldPostCode.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  inject: ['getPayinfo'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    cardInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
    vaultManager: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: {
    CvvInput,
    Field,
    FieldPostCode,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isShowPostCode']),
    ...mapState({
      postcode: (state) => state.user.postcode,
    }),
  },
  methods: {
    async validate() {
      const cvvAns = this.$refs.cvvInput.validate()

      const arr = [cvvAns.valid]
      const value = {
        selectID: this.cardInfo.id,
        cvv: cvvAns.value,
      }

      if (this.isShowPostCode) {
        const postcodeAns = await this.$refs.postcodeInput.validatePostcode()
        arr.push(postcodeAns)
        value.postcode = this.getPayinfo().post_code
      }

      return {
        valid: arr.every(Boolean),
        value,
      }
    },
  },
}
</script>
<style lang="less">
@import '../../cardField.less';
</style>
<style lang="less" scoped>
.card_field {
  .card_filed_con {
    .card_input_label {
      color: #62676b;
    }
  }
}
.card_item {
  border-bottom: 1px solid rgba(230, 230, 230, 1);
  .local_card_title {
    width: 100%;
    height: 60px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    .card_number {
      display: flex;
      .icon_radio {
        width: 20px;
        height: 20px;
        .bg-image('icon_radio');
        &.active {
          .bg-image('icon_radio_active');
        }
      }
      .cardlogo {
        height: 22px;
        width: auto;
        margin-left: 15px;
        margin-right: 16px;
      }
    }
    .card_delete {
      color: rgba(135, 141, 150, 1);
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .cvclocalCon {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    transition: height 0.2s ease-in-out;
  }
}
</style>
